import apiUrl from '../../../constants'
import commonFunction from '../../../commonFunction'
import constantVariable from '../../../constantVariable'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker';
import { AES, enc } from 'crypto-js';
import {
	ModelListSelect,
	BasicSelect,
} from 'vue-search-select';

import MultiSelect from 'vue-multiselect'

  import 'vue-multiselect/dist/vue-multiselect.min.css';


import FileUpload from 'v-file-upload';

import authFunction from '../../../authFunction';

import moment from 'moment';
import JQuery from 'jquery';
let $ = JQuery

Vue.use(FileUpload);
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.filter('formatDate', function (value) {

	if (value) {
		return moment(String(value)).format('DD-MM-YYYY hh:mm')
	}

});

export default {
	name: 'csawsshipment',
	components: {
		Paginate,
		DatePicker,
		ModelListSelect,
		BasicSelect,
		Loading,
		MultiSelect
	},
	data() {
		return {
			isLoadingPagination: false,
			fullPage: false,
			hubSelect: true,
			showList: 0,
			listTotalCount: 0,
			page: 'csawshipments',
			ticketLabel: 'Add Ticket',
			userTypeForTicket: '',
			ARRANGED_ASSIGN_OPS_TEAM: 11,
			ADDRESS_UPDATED: 8,
			ASSIGNED_OPS_TEAM: 12,
			STATUS_CHANGED: 15,
			ADDRESS_CHANGE: 9,
			FAKE_NDR: 133,
			REFUSED_DOORSTEP_DELIVERY: 136,
			DELAY_IN_PICKUP_SUB_REASON: 131,
			FAKE_NPR: 119,
			FAKE_PICKUP: 120,
			DENIED_PICKUP: 121,
			escalation: 0,
			fakeNdrStatus: 0,
			ticketResultMsg: '',
			ticketResultModal: false,
			ticket: {
				disabled: false
			},
			submitted: false,
			ticketShipmentData: [],
			shipmentTickets: [],
			ticket: {},
			username: '',
			mobileNumber: '',
			ticketId: '',
			source: [],
			sourceId: '',
			zoneData: [],
			hubData: [],
			selectedZoneObj: {
        value: '',
        text: ''
      },
			selectedHubObj: {
        value: '',
        text: ''
      },
			selectedClientObj: {
        value: '',
        text: ''
      },
			selectedStatusCodeObj: {
        value: '',
        text: ''
      },
			selectedSourceObj: {
				value: '',
				text: ''
			},
			ticketType: [],
			ticketTypeId: '',
			selectedTicketObj: {
				value: '',
				text: ''
			},
			reason: [],
			reasonId: '',
			selectedReasonObj: {
				value: '',
				text: ''
			},
			subReason: [],
			subReasonId: '',
			selectedSubReasonObj: {
				value: '',
				text: ''
			},
			action: [],
			actionId: '',
			selectedActionObj: {
				value: '',
				text: ''
			},
			ticketStatus: [],
			ticketStatusId: '',
			selectedTicketStatusObj: {},
			searchOptions: [],
			searchId: '',
			selectedSearchObj: {
				value: '',
				text: ''
			},
			reAttemptDate: '',
			startDate: new Date(),
			endDate: new Date(),
			validated: false,
			shortcuts: [{
				text: 'Today',
				startDate: new Date()

			}],
			format: 'YYYY-MM-DD',
			disabledDates: {
				to: new Date(Date.now() - 8640000)
			},
			address: '',
			location: '',
			pincode: '',
			orderType: [{
					value: 'CashOnDelivery',
					text: 'CashOnDelivery'
				},
				{
					value: 'PrePaid',
					text: 'PrePaid'
				}
			],
			orderTypeId: '',
			selectedOrderTypeObj: {
				value: '',
				text: ''
			},
			comments: '',
			email: '',
			userid: '',
			OldDeliveryUserOrUserId: '',
			DepartmentID: '',
			DepartmentName: '',
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			pageCount: 0,
			pageNo: 0,
			isLoading: false,
			perPage: 50,
			resultCount: '',
			formattedDate: '',
			search: {
				shippingid: '',
				criteria: 'csawupdate',
				scawtype: 'Forward',
				client: '',
				statuscode: '',
				zone: '',
				getHubList: '',
				hub: '',
				notificationtype: '',
				notificationstatus: '',
				withbucket: '',
			},
			fromDate: '',
			toDate: '',
			tillDate1: '',
			tillDate2: '',
			clientData: [],
			statusCodeData: [],
			scawshipments: [],
			notificationTypesData: [],
			notificationStatusData: [{
				statusvalue: "Pending",
				statustext: "Pending"
			}, {
				statusvalue: "ClientInstructionAwaiting",
				statustext: "Client Instruction Awaiting"
			}, {
				statusvalue: "Hold",
				statustext: "Hold"
			}, {
				statusvalue: "Reattempt",
				statustext: "Reattempt"
			}, {
				statusvalue: "Escalation",
				statustext: "Escalation"
			}],
			withBucketData: [{
				statusvalue: "Pending",
				statustext: "Pending"
			}, {
				statusvalue: "ClientInstructionAwaiting",
				statustext: "Client Instruction Awaiting"
			}, {
				statusvalue: "Hold",
				statustext: "Hold"
			}, {
				statusvalue: "Reattempt",
				statustext: "Reattempt"
			}, {
				statusvalue: "Escalation",
				statustext: "Escalation"
			}],
			trackLogs: [],
			trackShippingLogs: [],
			Ticketmodal: false,
			ShipmentLogModal: false,
			ShipmentLog: {
				ShipmentLogCnt: '',
				ShipmentLogDiv: '',
				ShipmentLogElement: {
					CurrentHubID: '',
					HubName: '',
					UserProcess: '',
					Comments: '',
					UserName: '',
					ProcessLocation: '',
					CreatedDate: ''
				},
				ShipmentLogBarArr: [],
			},
			displayshippingid: '',
			ShipmentTransactionLogSummary: {
				OriginHubID: '',
				CurrentHubID: '',
				FinalDestinationID: '',
				DataReceived: '',
				OriginHubData: '',
				BusinessFlow: '',
				currentHubData: '',
				currentHubDataLiShow: true,
				currentHubDataDivShow: true,
				currentHubDataMainDivShow: true,
				DestinationHubData: '',
				ClientID: ''
			},
			selectAll: false,
			shippingIDS: [],
			clientItems:[],
			lastSelectClientItem:{}
		
		}
	
	},
	created: function () {

		// this.getTrackingSource();
		// this.getSearchtags(this.search.scawtype);
		var typeList = [{
			typename: "CSAW",
		}, {
			typename: "CSAWRTO",
		}];
		this.notificationTypesData = typeList;
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momentdate: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momenttime: function (date) {
			if (!date)
				return;
			return moment(date).format('HH:mm:ss');
		}
	},
	mounted() {
		[this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj] = commonFunction.getuserDetailsAndpermissionData();
		this.accessRestrictor();
		this.userid = this.userdetail[0].userid;
		this.username = this.userdetail[0].username;
        this.userRole = this.userdetail[0].roles[0].rolename;
		this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
		this.getZoneList();
		this.getClientList();
		this.getStatusCodeList(this.search.scawtype);

	}, // End computed
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).add(1, 'd').format('YYYY-MM-DD');
		},
		setClient(){
	//					console.log("In set client")
			if(this.clientItems.length==0){
				return undefined;
			}
			else return this.clientItems[0].text
		},
		resetAll: function (myAction) {
			if (myAction == 1) {
				this.rackIds = [];
				this.shippingIDS = false;
				this.ticketShipmentData = false;
			} else {

			}
		},

		selectedZone(selectedZoneData) {
      this.selectedZoneObj = selectedZoneData;
      this.search.zone = selectedZoneData.value;
      this.getHubList();
    },

		selectedClientData(selectedClientData) {
			// console.log("SSSSSSSSSSSSSSSSSs")
      this.selectedClientObj = selectedClientData;
      this.search.client = selectedClientData.value;
    },
		selectedStatusCodeData(selectedStatusCodeData) {
      this.selectedStatusCodeObj = selectedStatusCodeData;
      this.search.statuscode = selectedStatusCodeData.value;
    },

		selectedHubData(selectedHubData) {
      this.selectedHubObj = selectedHubData;
      this.search.hub = selectedHubData.value;
    },

		selectAllCheckbox: function () {
			//this.rackIds = [];
			if (this.selectAll) {
				var i = 0;

				for (let shipid in this.scawshipments) {

					if (this.shippingIDS.indexOf(this.scawshipments[shipid].shippingid) == -1) {
						this.shippingIDS.push(this.scawshipments[shipid].shippingid);

						this.ticketShipmentData.push({
							'index': i,
							'shippingData': {
								'shippingid': this.scawshipments[shipid].shippingid,
								'currenthubid': this.scawshipments[shipid].currenthubid,
								'NotificationStatus': this.scawshipments[shipid].notificationstatus,
								'NotificationType': this.scawshipments[shipid].notificationtype,
								'clientname': this.scawshipments[shipid].clientname,
								'status': this.scawshipments[shipid].status,
								'shipmentstatus': this.scawshipments[shipid].shipmentstatus,
								'businessflow': this.scawshipments[shipid].businessflow,
								'UserProcess': this.scawshipments[shipid].latestprocess,
								'totalattempts': this.scawshipments[shipid].totalattempts,
								'createdOn': this.scawshipments[shipid].createdOn
							}
						});
					}
					i++;
				}
			} else {
				for (let shipid in this.scawshipments) {
					if (this.shippingIDS.indexOf(this.scawshipments[shipid].shippingid) >= 0) {

						this.shippingIDS.splice(this.shippingIDS.indexOf(this.scawshipments[shipid].shippingid), 1);
						this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == this.scawshipments[shipid].shippingid), 1);
					}
				}
			}
		},
		select: function (selectedObj, index, event) {

			this.allSelected = false;
			if (event.target.checked) {
				this.ticketShipmentData.push({
					'index': index,
					'shippingData': {
						'shippingid': selectedObj.shippingid,
						'currenthubid': selectedObj.currenthubid,
						'NotificationStatus': selectedObj.notificationstatus,
						'NotificationType': selectedObj.notificationtype,
						'clientname': selectedObj.clientname,
						'status': selectedObj.status,
						'shipmentstatus': selectedObj.shipmentstatus,
						'businessflow': selectedObj.businessflow,
						'UserProcess': selectedObj.latestprocess,
						'totalattempts': selectedObj.totalattempts,
						'createdOn': selectedObj.createdOn
					}

				});
			} else {
				this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == index), 1);
			}
		},
		csawTypeSelection() {
			this.isLoading = true;
			this.scawshipments = [];
			this.fromDate = '';
			this.toDate = '';
			this.hubSelect = true;
			this.search = {
				criteria: this.search.criteria,
				scawtype: this.search.scawtype,
				shippingid: '',
				client: '',
				statuscode: '',
				zone: '',
				hub: '',
				notificationtype: '',
				notificationstatus: '',
				withbucket: '',
			};
			this.hubSelect = true;
			this.shippingIDS = [];
			this.selectAll = false;
			this.pageNo = this.pageCount = 0;
			this.getStatusCodeList(this.search.scawtype);
			this.listTotalCount = 0;
			var typeList = [];
			if (this.search.scawtype == "Forward") {

				typeList = [{
					typename: "CSAW",
				}, {
					typename: "CSAWRTO",
				}];
			} else if (this.search.scawtype == "Reverse") {
				typeList = [{
					typename: "CSAW",
				}, {
					typename: "CSAWDTO",
				}];
			}

			this.notificationTypesData = typeList;
			this.selectedStatusCodeObj = {
        value: '',
        text: ''
      };
			this.selectedZoneObj = {
        value: '',
        text: ''
      };
			this.selectedClientObj = {
        value: '',
        text: ''
      };
			this.clientItems=[]
			this.selectedHubObj = {
        value: '',
        text: ''
      };
			// this.isLoading=false;
		},

		openTicketModal() {
			this.resetAddTicket();
			if (this.ticketShipmentData.length == 0) {
                this.$alertify.error('Please select shipment to create ticket.');
                return false;
			}
			this.getTrackingSource();
			this.getSearchtags(this.search.scawtype);
			this.Ticketmodal = true;
		},

		getClientList() {
			try {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getClientListCSAW',
						'data': {
							BusinessFlow: "Forward",
							BusinessService: "Delivery"
						},
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						// console.log("result is :",result)
						let data=result.data;
						this.clientData=data;
						// console.log("data is :",data);
						// for(let i=0;i<data.length;i++){
						// 	this.clientData.push(data[i]);
						// }
						// return;
						// var data = result.data.data.data.data;


						// for (var i = 0; i < data.length; i++) {
						// 	console.log("Data 0 is :",data[0]);
						// 	this.clientData.push({
						// 		value: data[i].ClientBusinessAccountId,
						// 		text: data[i].AccountName
						// 	})
						// }
						// console.log("client data is :",this.clientData);
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getClientList";
				this.$alertify.error(msg);
			}
		},
		getStatusCodeList(scawtype) {
			try {
				//this.isLoading=true;
				this.showList = 0;
				this.statusCodeData = [];
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				var whereData = {};
				var isNDR = 1;
				if (scawtype == 'Forward') {
					whereData = {
						ShipmentType: "Forward",
						IsNDR: isNDR.toString()
					}
				}
				if (scawtype == 'Reverse') {
					whereData = {
						ShipmentType: "RVP",
						IsNDR: isNDR.toString()
					}
				}
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getScawStatusCodeList',
						'data': whereData,
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						this.isLoading = false;
						var data = result.data.data.data.data;
						for (var i = 0; i < data.length; i++) {
							this.statusCodeData.push({
								value: data[i].userprocessmappingid,
								text: data[i].userprocess
							})
						}
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getStatusCodeList";
				this.$alertify.error(msg);
			}
		},

		getTrackLogs(shipingid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			let token = 'c423ed60f34c0021016fc65cb53a9ad4';
			let versionNumber = 'v1';
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetTrackLogs',
					'data': {
						ShippingID: shipingid,
					},
					headers: commonFunction.getusertoken(),
				})
				.then(result => {
					this.trackLogs = result.data.data.data.ShipmentDetails;
				}, error => {
					console.error(error);
				});
		},

		getZoneList() {
			try {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getZoneList',
						'data': {},
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						var data = result.data.data.data.data;
						for (var i = 0; i < data.length; i++) {
							this.zoneData.push({
								value: data[i].hubzoneid,
								text: data[i].hubzonename
							})
						}
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getZoneList";
				this.$alertify.error(msg);
			}
		},

		async getHubList() {
			try {
				this.hubData = [];
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.hubSelect = true;
				this.search.hub = '';
				if (this.search.zone) {
					await axios({
							method: 'POST',
							'url': apiUrl.api_url + 'getHubList',
							'data': {
								id: this.search.zone
							},
							headers: commonFunction.getusertoken(),
						})
						.then(result => {
							this.hubSelect = false;
							var data = result.data.data.data.data;
							for (var i = 0; i < data.length; i++) {
								this.hubData.push({
									value: data[i].HubID,
									text: data[i].HubName
								})
							}
						}, error => {
							this.hubSelect = true;
							console.error(error);
						});
				} else {
					this.hubSelect = true;
					this.hubData = []
				}
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getHubList";
				this.$alertify.error(msg);
			}
		},
		onChange: function () {
			if (this.fromDate != null && this.toDate != null) {
				if (this.fromDate != '') {
					let dateDisabled = new Date(this.fromDate);
					this.tillDate1 = new Date();
					dateDisabled.setDate(this.fromDate.getDate() + 14);
					this.tillDate1 = dateDisabled;
				}
				if (this.toDate != '') {
					let dateDisabled2 = new Date(this.toDate);
					this.tillDate2 = new Date();
					dateDisabled2.setDate(this.toDate.getDate() - 14);
					this.tillDate2 = dateDisabled2;
				}
			} else {
				this.fromDate = '';
				this.toDate = '';
				this.tillDate1 = '';
				this.tillDate2 = '';
			}
		},

		// myFunction: function  () {
		// document.getElementById('calenderDiv').style.height = '50px';
		// },

		async getPaginationData(pageNum) {

			this.pageNo = (pageNum - 1) * this.perPage;

			await this.getCSAWShipmentData();
		},
		getCSAWShipmentData(csvCheck = '') {
			try {
				console.log("In getCSAWShipmentData function")
				this.selectAll = false;
				this.ticketShipmentData = [];
				this.shippingIDS = [];

				var searchData = {};
				this.isLoading = true;
				this.listTotalCount = 0;
				if (this.search.scawtype == 'Forward') {
					searchData = {
						shippingid: this.search.shippingid,
						fromdate: this.dateFormat1(this.fromDate),
						todate: this.dateFormat2(this.toDate),
						notificationtype: this.search.notificationtype,
						client:this.setClient(),
						statuscode: this.selectedStatusCodeObj.text,
						notificationstatus: this.search.notificationstatus,
						zone: this.selectedZoneObj.text,
						hub: this.search.hub,
						businessflow: 'Forward',
						offset: this.pageNo,
						limit: this.perPage,
						csvData: csvCheck,
						criteria: this.search.criteria
					}
				} else {
					searchData = {
						shippingid: this.search.shippingid,
						fromdate: this.dateFormat1(this.fromDate),
						todate: this.dateFormat2(this.toDate),
						notificationtype: this.search.notificationtype,
						client:this.setClient(),
						zone: this.selectedZoneObj.text,
						hub: this.search.hub,
						statuscode: this.selectedStatusCodeObj.text,
						notificationstatus: this.search.notificationstatus,
						businessflow: 'Reverse',
						offset: this.pageNo,
						limit: this.perPage,
						csvData: csvCheck,
						criteria: this.search.criteria
					}
				}
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getScawShipmentListing',
						'data': searchData,
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						if (result.data.data) {
							this.showList = 1;
							this.scawshipments = result.data.data.data;
							this.getTrackingSource();
							this.getSearchtags(this.search.scawtype);
							if (result.data.data.errorCode == -1) {
								this.resultCount = 0;
								this.pageCount = 0;

							} else {
								if (this.scawshipments.length > 0) {
									var totalRows = result.data.data.resultsAll[0].full_count;
									this.listTotalCount = totalRows;

									if (totalRows < this.perPage) {
										this.pageCount = 1;
										this.pageNo = 0;
									} else {
										this.pageCount = Math.ceil(totalRows / this.perPage)
									}
								} else {
									this.pageCount = 0;
								}
							}
						} else {
							this.$alertify.error("API Server Error - getScawShipmentListing");
						}
						this.isLoading = false;
						this.isLoadingPagination = false;
					}, error => {
						this.isLoading = false;
						this.isLoadingPagination = false;
						var commonVariable = commonFunction.showNetworkError(error);
						this.$alertify.error(commonVariable);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getCSAWShipmentData";
				this.$alertify.error(msg);
			}
		},

		exportCSAWListing() {
			try {
				if (this.search.shippingid == '') {
					if (this.fromDate === '') {
						this.$alertify.error('Please select From Date.');
						return false;
					}
					if (this.toDate === '') {
						this.$alertify.error('Please select To Date.');
						return false;
					}
					if (this.search.notificationtype === '') {
						this.$alertify.error('Please select Notification Type.');
						return false;
					}
					if (this.search.notificationstatus === '') {
						this.$alertify.error('Please select Notification Status.');
						return false;
					}
					if (this.search.hub === '' && this.search.zone != '') {
						this.$alertify.error('Please select hub after selecting zone.');
						return false;
					}
				}

				var searchData = {};
				this.isLoading = true;
				if (this.search.scawtype == 'Forward') {
					searchData = {
						shippingid: this.search.shippingid,
						fromdate: this.dateFormat1(this.fromDate),
						todate: this.dateFormat2(this.toDate),
						notificationtype: this.search.notificationtype,
						client:this.setClient(),
						statuscode: this.selectedStatusCodeObj.text,
						notificationstatus: this.search.notificationstatus,
						zone: this.selectedZoneObj.text,
						hub: this.search.hub,
						businessflow: 'Forward',
						criteria: this.search.criteria
					}
				} else {
					searchData = {
						shippingid: this.search.shippingid,
						fromdate: this.dateFormat1(this.fromDate),
						todate: this.dateFormat2(this.toDate),
						notificationtype: this.search.notificationtype,
						client:this.setClient(),
						zone: this.selectedZoneObj.text,
						hub: this.search.hub,
						statuscode: this.selectedStatusCodeObj.text,
						notificationstatus: this.search.notificationstatus,
						businessflow: 'Reverse',
						criteria: this.search.criteria
					}
				}
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'exportCSAWListing',
						'data': searchData,
						responseType: 'blob', // important
						headers: commonFunction.getusertoken(),
					})
					.then(response => {
						this.isLoading = false;
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'CSAWShipmentReport.xlsx');
						document.body.appendChild(link);
						link.click();

					}, error => {
						this.isLoading = false;
						this.isLoadingPagination = false;
						var commonVariable = commonFunction.showNetworkError(error);
						this.$alertify.error(commonVariable);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - exportCSAWListing";
				this.$alertify.error(msg);
			}
		},

		searchButton() {
			if (this.search.shippingid == '') {
				if (this.fromDate === '') {
					this.$alertify.error('Please select From Date.');
					return false;
				}
				if (this.toDate === '') {
					this.$alertify.error('Please select To Date.');
					return false;
				}
				if (this.search.notificationtype === '') {
					this.$alertify.error('Please select Notification Type.');
					return false;
				}
				if (this.search.notificationstatus === '') {
					this.$alertify.error('Please select Notification Status.');
					return false;
				}
				if (this.search.hub === '' && this.search.zone != '') {
					this.$alertify.error('Please select hub after selecting zone.');
					return false;
				}				
				//return false;
			}
			// console.log("Come hereeeeeeeee");
			this.pageNo = this.pageCount = 0;
			this.getCSAWShipmentData();

		},

		closeBModalCommonFunction(string) {
			var tempvariable;
			[this.filter, this.Ticketmodal, tempvariable, tempvariable, tempvariable, tempvariable, this.ShipmentLogModal, tempvariable, this.ticketResultModal, string] = commonFunction.closeBModalCommonFunction(string);
		},

		showShipmentLogModal(shippingid) {
			try {
				this.ShipmentLog.ShipmentLogBarArr = [];
				this.isLoading = true;
				let token = 'c423ed60f34c0021016fc65cb53a9ad4';
				let versionNumber = 'v1';
				let xbkey = 'xbkey2';
				this.input = ({
					ShippingID: shippingid
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'GetTrackShipmentLogDetails',
						'data': this.input,
						headers: commonFunction.getusertoken(),
					})
					.then(result => {

						this.displayshippingid = shippingid;
						this.isLoading = false;
						let resultDataCrm = result.data.data;
						if (resultDataCrm.status) {
							let resultData = result.data.data.data;
							if (resultData.ReturnCode === 100) {
								this.ShipmentLog.ShipmentLogBarArr = resultData.Result;
								this.ShipmentLog.ShipmentLogCnt = this.ShipmentLog.ShipmentLogBarArr.length;
								for (let i = 0; i < this.ShipmentLog.ShipmentLogCnt; i++) {
									if (this.ShipmentLog.ShipmentLogBarArr[i].CurrentHubName > 0) {
										this.getHubDetailById(this.ShipmentLog.ShipmentLogBarArr[i].CurrentHubName, i);
									}
								}
								this.ShipmentLogModal = true
							} else {
								let msg = resultData.ReturnMessage;
								this.$alertify.error(msg);
							}
						} else {
							let msg = resultDataCrm.msg;
							this.$alertify.error(msg);
						}
					}, error => {
						let msg = error;
						this.$alertify.error(msg);
					})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - showShipmentLogModal";
				this.$alertify.error(msg);
			}
		},

		getHubDetailById(HubId, HubSource) {
			try {
				const secretKey = constantVariable.enckey;
				const encryptedData = AES.encrypt(HubId.toString(), secretKey).toString();
				let ecHubId = encryptedData.replace(/[=]/g, '_');
				this.input = ({
					id: ecHubId
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getHubDetailById',
						'data': this.input,
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						let resultDataCrm = result.data.data;
						if (resultDataCrm.status) {
							let response = resultDataCrm.data;
							let HubNameStr = '';
							let ProcessLocation = '';
							if (response.code === 200) {
								HubNameStr = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
								if (HubSource === "O") {
									this.ShipmentTransactionLogSummary.OriginHubData = this.ShipmentTransactionLogSummary.OriginHubData + " " + HubNameStr;
								}
								if (HubSource === "C") {
									this.ShipmentTransactionLogSummary.currentHubData = HubNameStr;
									this.OrderDetails.EmailServiceCenter = response.data[0].HubEmailId;
								}
								if (HubSource === "D") {
									this.ShipmentTransactionLogSummary.DestinationHubData = this.ShipmentTransactionLogSummary.DestinationHubData + " " + HubNameStr;
								} else if (HubSource >= 0) {
									HubNameStr = response.data[0].HubName;
									// For ShipmentLog ProcessLocation
									ProcessLocation = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
									this.ShipmentLog.ShipmentLogBarArr[HubSource].ProcessLocation = ProcessLocation;
									this.ShipmentLog.ShipmentLogBarArr[HubSource].HubName = HubNameStr;
									this.ShipmentLog.ShipmentLogBarArr[HubSource].CurrentHubName = HubNameStr;
								}
							} else {
								let msg = response.message;
								//this.$alertify.error(msg, 1);
							}

						} else {
							let msg = resultDataCrm.msg;
							//this.$alertify.error(msg, 2);
						}
					}, error => {
						let msg = error;
						//this.$alertify.error(msg, 3);
					})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getHubDetailById";
				this.$alertify.error(msg);
			}
		},
		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();

			}).catch(() => {

			});
		},

		handleFileUpload() {

			this.file = this.$refs.file.files[0];

			if (['xls', 'xlsx'].indexOf(this.file.name.split('.')[this.file.name.split('.').length - 1]) === -1) {
				this.$alertify.error('Please upload file with .xls, .xlsx extensions.');
				document.getElementById('file').value = '';

			}
		},

		submitFile() {

			let token = 'edw3r323432472748923';
			let formData = new FormData();
			formData.append('file', this.file);

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'uploadExcel',
				'data': formData,
				headers: commonFunction.getusertoken(),
			}).then(result => {

				if (result.data.data.status == true) {

					this.excelFileUploadPath = result.data.data.data;
					this.$alertify.success(result.data.data.msg);

				} else {
					this.$alertify.error(result.data.data.msg);
				}

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
			return false;
		},

		resetAddTicket() {

			this.sourceId = '';
			this.selectedSourceObj = {
				value: '',
				text: ''
			};

			this.ticketTypeId = '',
				this.selectedTicketObj = {
					value: '',
					text: ''
				};

			this.reasonId = '',
				this.selectedReasonObj = {
					value: '',
					text: ''
				};

			this.subReasonId = '',
				this.selectedSubReasonObj = {
					value: '',
					text: ''
				};

			this.actionId = '',
				this.selectedActionObj = {
					value: '',
					text: ''
				};

			this.ticketStatusId = '',
				this.selectedTicketStatusObj = {
					value: '',
					text: ''
				};

			this.searchId = '';
			this.selectedSearchObj = {
				value: '',
				text: ''
			};
			this.reAttemptDate = '';
			this.allSelected = false;
			this.comments = '';
			// this.listTotalCount = 0;
		},

		resetForm() {
			this.showList = 0;
			var self = this; //you need this because *this* will refer to Object.keys below`
			this.listTotalCount = 0;
			// changes by sunny
			this.hubSelect = true;
			this.scawshipments = [];
			this.fromDate = '';
			this.toDate = '';
			this.search = {
				shippingid: '',
				criteria: 'csawupdate',
				scawtype: 'Forward',
				client: '',
				statuscode: '',
				zone: '',
				hub: '',
				notificationtype: '',
				notificationstatus: '',
				withbucket: '',
			};
			this.selectedStatusCodeObj = {
				value: '',
				text: ''
			};
			this.selectedZoneObj = {
				value: '',
				text: ''
			};
			this.selectedClientObj = {
				value: '',
				text: ''
			};
			this.selectedHubObj = {
				value: '',
				text: ''
			};
			this.clientItems=[];
		},

		getTrackingSource() {
			try {
				let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
				let accessToken;

				this.isLoading = true;
				let token = 'edw3r323432472748923';

				this.input = ({
					'departmentid': '1',
					'usertype': 'Agent'
				});

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getTrackingSource',
					'data': this.input,
					headers: commonFunction.getusertoken(),
				}).then(result => {
					this.isLoading = false;;
					this.source = result.data.data.data;

				}, error => {
					this.isLoading = false;
					var commonVariable = commonFunction.showNetworkError(error);
					this.$alertify.error(commonVariable);
				})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getTrackingSource";
				this.$alertify.error(msg);
			}
		},

		selectedSource(sourceData) {
			try {
				this.selectedSourceObj = sourceData;
				this.sourceId = sourceData.value;
				this.getTrackingMainType();
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedSource";
				this.$alertify.error(msg);
			}
		},

		selectedTicket(ticketData) {
			try {
				this.selectedTicketObj = ticketData;
				this.ticketTypeId = ticketData.value.toString();
				this.selectedReasonObj = {};
				this.selectedSubReasonObj = {};
				this.subReason = [];
				this.selectedActionObj = {};

				this.getTrackingSubType(this.ticketTypeId, this.search.scawtype);
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedTicket";
				this.$alertify.error(msg);
			}
		},

		selectedReason(reasonData) {
			try {
			this.selectedReasonObj = reasonData;
			this.reasonId = reasonData.value.toString();
			this.selectedSubReasonObj = {};
			this.selectedActionObj = {};
			this.selectedTicketStatusObj = {};
			this.ticketStatusId = '';

			this.getTrackingType(this.reasonId, this.search.scawtype);
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedReason";
				this.$alertify.error(msg);
			}

		},

		selectedSubReason(subReasonData) {
			try {
			this.reAttemptDate = '';

			this.selectedSubReasonObj = subReasonData;
			this.subReasonId = subReasonData.value.toString();
			this.selectedActionObj = {};
			this.selectedTicketStatusObj = {};
			this.ticketStatusId = '';
			this.escalation = subReasonData.isescalation;
			this.getTicketAction(this.subReasonId, 'Add');
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedSubReason";
				this.$alertify.error(msg);
			}
		},

		selectedAction(actionData) {
			try {
				if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' && this.selectedSubReasonObj.text !== 'Change Reattempt Date' &&
					this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
					this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service') {

				this.endDate = null;
					if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed') {
						let tomorrow = new Date();
					if (this.startDate.getHours() < 20) {
							tomorrow.setDate(tomorrow.getDate() + 1);
						this.startDate = tomorrow;
					} else {
						tomorrow.setDate(tomorrow.getDate() + 2);
						this.startDate = tomorrow;
					}
					let dateDisabled = new Date();
					dateDisabled.setDate(dateDisabled.getDate() + 7);
					this.endDate = dateDisabled;
				}
			} else {
					this.startDate = new Date();
				let dateDisabled2 = new Date();
				dateDisabled2.setDate(dateDisabled2.getDate() + 6);
				this.endDate = dateDisabled2;
			}

			this.selectedActionObj = actionData;
			this.actionId = actionData.value.toString();
			this.getTicketActionStatus(actionData.value);
			} catch (error) {
			this.isLoading = false;
				let msg = error + " - selectedAction";
			this.$alertify.error(msg);
		  }
		},


		selectedTicketStatus(ticketStatusData) {
			this.selectedTicketStatusObj = ticketStatusData;
			this.ticketStatusId = ticketStatusData.value.toString();
		},

		selectedSearchTag(SelectedTagData) {
			try {
			this.selectedSearchObj = SelectedTagData;
			this.searchId = SelectedTagData.value.toString();
			this.getSearchResult(SelectedTagData.id, SelectedTagData.type, this.search.scawtype);
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedSearchTag";
				this.$alertify.error(msg);
			}
		},

		getTicketActionStatus(actionId) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				actionId: actionId,
				status: 'Add'
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTicketActionStatus',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {

				this.isLoading = false;
				if (result.data.data.status == true) {
					let arrStatus = [];
					this.ticketStatus = [];
					arrStatus = result.data.data.data[0].ticketstatus.toString().split(",");

					for (let i = 0; i < arrStatus.length; i++) {
						this.ticketStatus.push({
							'value': arrStatus[i],
							'text': arrStatus[i]
						});
					}

					this.selectedTicketStatusObj = this.ticketStatus[0];
					this.ticketStatusId = this.selectedTicketStatusObj.value;
				}

			}, error => {

				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTrackingMainType() {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				'departmentid': '1',
				'page': this.page
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTrackingMainType',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.ticketType = result.data.data.data;

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTrackingSubType(mainTypeId, businessFlow) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';
			const secretKey = constantVariable.enckey;
			const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
			let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
			this.input = ({
				'departmentid': ecDepartmentID,
				'maintypeid': mainTypeId,
				'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
				'page': this.page
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTrackingSubType',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.reason = result.data.data.data;
								if (this.reason) {

				} else {
					let msg = constantVariable.UNAUTORISED_USER_MSG;
					this.$alertify.error(msg);
				}

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTrackingType(subTypeId, businessFlow) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				'departmentid': this.DepartmentID,
				'subtypeid': subTypeId,
				'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
				'page': this.page,
				'notificationType': '',
				'notificationStatus': '',
				'status': ''
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTrackingType',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
			    this.subReason = result.data.data.data;
if (this.subReason) {

	let subReasonTempData = [];

	if (this.search.scawtype == 'Forward' || this.search.scawtype == 'Reverse') {
		// if ((this.SalesDemo.ClientID != constantVariable.ICICI_BANK_LTD && this.SalesDemo.ClientID != constantVariable.RBL_BANK) && this.SalesDemo.BusinessType != 'BFSI') {

		var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
		if (-1 !== indexRedirectBank) {
			this.subReason.splice(indexRedirectBank, 1);
		}
		var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
		if (-1 !== indexSecondaryBank) {
			this.subReason.splice(indexSecondaryBank, 1);
		}
		var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

		if (-1 !== indexPrimaryBank) {
			this.subReason.splice(indexPrimaryBank, 1);
		}

	} else {

		var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
		if (-1 !== indexRedirectBank) {
			subReasonTempData.push(this.subReason[indexRedirectBank]);
			// this.subReason.splice(indexRedirectBank, 1);
		}

		var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
		if (-1 !== indexSecondaryBank) {
			subReasonTempData.push(this.subReason[indexSecondaryBank]);
			// this.subReason.splice(indexSecondaryBank, 1);
		}

		var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

		if (-1 !== indexPrimaryBank) {
			subReasonTempData.push(this.subReason[indexPrimaryBank]);
			//  this.subReason.splice(indexPrimaryBank, 1);
		}

		this.subReason = subReasonTempData;
	}

} else {
	let msg = constantVariable.UNAUTORISED_USER_MSG;
        this.$alertify.error(msg);
}

			}, error => {
				this.isLoading = false;
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTicketAction(subReasonId, status) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				subReasonId: subReasonId,
				status: status,
				'page': this.page,
				"departmentId": this.DepartmentID,
				 role: this.userRole
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTicketAction',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.action = result.data.data.data;
                if (this.action) {

					let flag = false;
					let rvpflag = false;

					var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');
					if (-1 !== indexCsTeam) {
						if (this.search.scawtype == 'Forward' || this.search.scawtype == 'Banking Client') {
							this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
						}
						if (this.search.scawtype == 'Reverse') {
							this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
						}
					}

					if (this.subDepartmentList) {
					  for (var i = 0; i < this.subDepartmentList.length; i++) {
							if ((this.search.scawtype == 'Forward' || this.search.scawtype == 'Banking Client') && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
								if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
								flag = true;
								break;
							}
						 }
					  }
					  for (var i = 0; i < this.subDepartmentList.length; i++) {

							if (this.search.scawtype == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
								if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
								  rvpflag = true;
								  break;
							}
						 }
					  }
					}

					if ('Admin' !== this.userRole && flag == false) {
						var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
						if (-1 !== indexRTONotify) {
							if (this.search.scawtype == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
								this.action.splice(indexRTONotify, 1);
							}
							if (this.search.scawtype == 'Reverse') {
								this.action.splice(indexRTONotify, 1);
							  }
						}
					}

					if ('Admin' !== this.userRole) {
						var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

						if (-1 !== indexPickupCancelled) {

							if (this.search.scawtype == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
								this.action.splice(indexPickupCancelled, 1);
							}

							if (this.search.scawtype == 'Forward') {
								this.action.splice(indexPickupCancelled, 1);
							}

						}
					}


					if (this.selectedSubReasonObj.text == 'Delay in service' || this.selectedSubReasonObj.text == 'Fake update' ||
						this.selectedSubReasonObj.text == '"PDD Crossed' || this.selectedTicketObj.text == 'Request') {

						 var indexAction = this.action.findIndex(o => o.text == 'Information given');
						if (-1 !== indexAction) {
							this.action.splice(indexAction, 1);
						}
					}


				} else {
					let msg = constantVariable.UNAUTORISED_USER_MSG;
        this.$alertify.error(msg);
				}

			}, error => {
				this.isLoading = false;
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getSearchtags(businessFlow) {
			try {
			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';
const secretKey = constantVariable.enckey;
				const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
				let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
			this.input = ({
				"departmentid": ecDepartmentID,
				'businessFlow': businessFlow,
				"page": this.page
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSearchOption',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.searchOptions = result.data.data.data;

				Object.entries(this.searchOptions).forEach(entry => {
					entry[1].value = entry[1].id;
					entry[1].text = entry[1].name;
				});

			}, error => {
				this.isLoading = false;
					var commonVariable = commonFunction.showNetworkError(error);
				this.$alertify.error(commonVariable);
			})
			} catch (error) {
		  this.isLoading = false;
				let msg = error + " - getSearchtags";
		  this.$alertify.error(msg);
	  }
	},

		getSearchResult(id, type, businessFlow) {
			let accessToken;
			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				"id": id,
				"type": type,
				"businessFlow": businessFlow,
				"page": this.page,
				"departmentId": this.DepartmentID,
				"role": this.userRole
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSearchResult',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;

				if (undefined !== result.data.data.data.main_data) {
					this.ticketType = result.data.data.data.main_data;
					this.selectedTicketObj = this.ticketType.find(o => o.selected == 1);
					this.ticketTypeId = this.selectedTicketObj.value;
				}

				if (undefined !== result.data.data.data.sub_data) {
					this.reason = result.data.data.data.sub_data;
					this.selectedReasonObj = this.reason.find(o => o.selected == 1);
				}
				if (undefined !== this.selectedReasonObj) {
					this.reasonId = this.selectedReasonObj.value;
				} else {
					this.reasonId = '';
					this.selectedReasonObj = {};
				}

				if (undefined !== result.data.data.data.type_data) {
					this.subReason = result.data.data.data.type_data;
					this.selectedSubReasonObj = this.subReason.find(o => o.selected == 1);

					this.escalation = (undefined != this.selectedSubReasonObj) ? this.selectedSubReasonObj.isescalation : 0;
				}
				if (undefined !== this.selectedSubReasonObj) {
					this.subReasonId = this.selectedSubReasonObj.value;

				} else {
					this.subReasonId = '';
					this.selectedSubReasonObj = {};
				}

				if (undefined !== result.data.data.data.action_data) {
					this.action = result.data.data.data.action_data;
					var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');

					if (-1 !== indexCsTeam) {
						if (businessFlow == 'Forward') {
							this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
						} else {
							this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
						}
					}
					if (this.subDepartmentList) {
						for (var i = 0; i < this.subDepartmentList.length; i++) {
							if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
							if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
							  flag = true;
							  break;
							}
						  }
						}
						for (var i = 0; i < this.subDepartmentList.length; i++) {

							if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
							if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
							  rvpflag = true;
							  break;
							}
						  }
						}
					}
					if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
						if (flag == false) {
							let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
							if (-1 !== indexOpsTeam) {
								this.action.splice(indexOpsTeam, 1);
							} else {
							   this.action.push('Assigned to Fwd Client Support Team');
							}
						} else {
							let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
							if (-1 !== indexFwdCsTeam) {
								this.action.splice(indexFwdCsTeam, 1);
							}
						}
					}

					if ('Admin' !== this.userRole && flag == false) {
						var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
						if (-1 !== indexRTONotify) {
							if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
							   this.action.splice(indexRTONotify, 1);
							}

						}
					}
					if ('Admin' !== this.userRole) {
						var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

						if (-1 !== indexPickupCancelled) {

							if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
							this.action.splice(indexPickupCancelled, 1);
						  }

						}
					}

					this.selectedActionObj = {};
				}


				if (undefined !== this.selectedSubReasonObj) {
					this.subReasonId = this.selectedSubReasonObj.value;

				} else {
					this.subReasonId = '';
					this.selectedSubReasonObj = {};
				}

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		saveBulkShipment() {
			try {
			let accessToken;

			let token = 'edw3r323432472748923';

			if (this.ticketShipmentData.length == 0) {
				this.$alertify.error('Please select shipment to create ticket.');
				return false;
			}
			if (this.sourceId === '') {
				this.$alertify.error('Please select Source.');
				return false;
			}

			if (this.ticketTypeId === '') {
				this.$alertify.error('Please select Tiket Type.');
				return false;
			}

			if (this.reasonId === '') {
				this.$alertify.error('Please select Reason.');
				return false;
			}

			if (this.subReasonId === '') {
				this.$alertify.error('Please select Sub Reason.');
				return false;
			}

			if (this.actionId === '') {
				this.$alertify.error('Please select Action.');
				return false;
			}

			let attempDate = (this.reAttemptDate != null && this.reAttemptDate != '') ? this.reAttemptDate : '';

			if (attempDate.length != 10 && attempDate !== '') {
					attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
			}

			if (9 == this.reasonId && this.excelFileUploadPath === '' && this.selectedBusinessFlowObj.text == 'Forward') {
				this.$alertify.error('Please Upload excel for address.');
				return false;
			}

			if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
				this.fakeNdrStatus = 1;
			}

			if (this.selectedReasonObj.text == 'Arrange delivery') {

				if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Urgent delivery' ||
					this.selectedSubReasonObj.text == 'Self collect') {

					if (this.reAttemptDate == '') {
						this.$alertify.error('Please enter reattempt date.');
						return false;
					}
				}
			}

			if ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
					(this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update') ||
					this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR ||
					this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR ||
					this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) {

				if (this.reAttemptDate == '') {
					this.$alertify.error('Please enter reattempt date.');
					return false;
				}
			}

			if (this.selectedReasonObj.text == 'Arrange pickup') {

				if (this.selectedSubReasonObj.text == 'Future pickup' || this.selectedSubReasonObj.text == 'Urgent pickup' ||
					this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup') {

					if (this.reAttemptDate == '') {
						this.$alertify.error('Please enter reattempt date.');
						return false;
					}
				}
			}
			if (this.comments === '') {
				this.$alertify.error('Please enter comments.');
				return false;
			}

			this.input = ({
				sourceId: this.sourceId.toString(),
				ticketTypeId: this.ticketTypeId.toString(),
				reasonId: this.reasonId.toString(),
				subReasonId: this.subReasonId.toString(),
				action: this.actionId.toString(),
				ticketStatusId: this.ticketStatusId.toString(),
				reAttemptDate: attempDate,
				deptid: this.DepartmentID.toString(),
				userId: this.userid,
				username: this.username,
				shippingData: this.ticketShipmentData,
				filename: this.excelFileUploadPath,
				comments: this.comments,
				userType: this.userTypeForTicket,
				IsFakeNDRStatus: this.fakeNdrStatus,
					businessflow: this.search.scawtype,
				escalation: this.escalation,
					subReason: this.selectedSubReasonObj.text
			});

			this.isLoading = true;

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'createCswaTicket',
					'data': this.input,
					'min': 1,
					'idle': 10000,
					'acquire': 10000,
					'evict': 60000,
					'handleDisconnects': true,
					headers: commonFunction.getusertoken(),

			  	})
			  	.then(result => {


						if (result.data && result.data.data && result.data.data.status) {
							/*Start IP Tracking */
							let userTrackerObj = {};
							userTrackerObj.subReason = this.selectedSubReasonObj.text;
							userTrackerObj.ticketData = this.input.shippingData;
							userTrackerObj.userid = this.userid;
							userTrackerObj.username = this.username;
							userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
							userTrackerObj.projectname = apiUrl.project_name;
							userTrackerObj.trackurl = this.$route.path;
							userTrackerObj.eventTrack = "CSAWTicket " + userTrackerObj.subReason;
							authFunction.userTrackerCSAW(userTrackerObj);
							/*End IP Tracking */

							// To refresh the CSAW List 
							this.getCSAWShipmentData();

						}


				 	this.isLoading = false;
	  				this.ticketResultMsg = result.data.data.msg;
					this.ticketResultModal = true;
					this.ticketShipmentData = [];
						this.shippingIDS = [];
					this.resetAddTicket();

				}, error => {
					this.isLoading = false;
					console.error(error);
				})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - saveBulkShipment";
				this.$alertify.error(msg);
			}

		},

		// checkPinCodeServiceable
		checkPinCodeServiceable() {
			this.input = ({
				"businessunit": this.SalesDemo.BusinessType,
				"businessflow": this.SalesDemo.BusinessFlow,
				"businessservice": this.SalesDemo.ServiceType, //"Delivery",
				"pincode": this.pincode,
				"routemode": "surface",
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkPinCodeServiceable',
					headers: commonFunction.getusertoken(),
					'data': this.input
				})
				.then(result => {
					let resultDataCrm = result.data.data;

					if (resultDataCrm.status) {
						let response = resultDataCrm.data;
						if (response.code === 200) {
							this.$alertify.success('Pincode is serviceable.');
						} else {
							this.$alertify.error(response.message);
							//this.pincode = '';
							this.validated = true;
						}
					} else {
						this.$alertify.error(response.message);
						// this.pincode = '';
						this.validated = true;
					}
				}, error => {
					this.$alertify.error(error);
				})
		},

		accessRestrictor() {
			var desider = 0;
     var n = window.location.href.search('#');
			var link = window.location.href.substr(n + 1);
			var linkToo = window.location.href.substr(n + 2);
			for (let i = 0; i < this.permissiondata.length; i++) {
				if (link == this.permissiondata[i].url) {
         desider++;
       }
     }
			if (desider == 0) {
       this.$router.push('/dashboard');
				this.$alertify.error("Access Denied for " + linkToo + " Module.");
     }
   },
	

		onSelect (clientItems, lastSelectClientItem) {
			this.clientItems=[];
			
			this.clientItems.push(clientItems)
			// this.search.client=clientItems.value;
			// console.log("Value is :",this.search.client);
		  },

		//   reset () {
		// 	this.clientItems = [] // reset
		//   },
		  // select option from parent component
		//   selectOption () {
		// 	this.clientItems = _.unionWith(this.clientItems, [this.options[0]], _.isEqual)
		//   }
	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/CSAWShipments/csawshipments.component.js